import { useNavigate } from 'react-router-dom'
import * as actions from '../../../../store/slices'
import VerifyCode from '../../Components/HaveProductPurchased/VerifyCode'
import { useDispatch } from 'react-redux'
import { isInApp } from '../../../../utils/helpers/common'
import postMessageToRN, {
  GO_TO_APP,
} from '../../../../utils/helpers/ReactNativeEvents'

const ExtendPlan = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const onCodeVerified = () => {
    const payload = {}
    new Promise((resolve, reject) => {
      dispatch(actions.getPatientDetailsRequest({ payload, resolve, reject }))
    })
    dispatch(actions.resetVerifyCodeData())
    if (isInApp()) {
      postMessageToRN(GO_TO_APP)
    } else {
      navigate('/care-plans/viemax-program', { replace: true })
    }
  }
  return (
    <div>
      <VerifyCode onCodeVerified={onCodeVerified} isPlanExtension={true} />
    </div>
  )
}

export default ExtendPlan
